import { z, ZodSchema } from "zod";
import { UseFormReturn } from "react-hook-form";
import { FieldType, Form } from "@shared/features/form/Form";
import AuthActions from "../AuthActions/AuthActions";
import LoginAdditionalContent from "./LoginAdditionalContent";

export type Props = {
  onLogin: () => void;
  onLoginWithGoogle: () => void;
  fields: FieldType[];
  form: UseFormReturn<z.infer<ZodSchema>>;
  hideSignupLink?: boolean;
};

export function LoginForm({ onLogin, onLoginWithGoogle, fields, form, hideSignupLink }: Props) {
  const { isSubmitting, isLoading, isValid } = form.formState;

  return (
    <>
      <Form
        fields={fields}
        form={form}
        className="w-full"
        innerClassName="justify-center"
        errorContainerClassName="p-0 mt-8"
      />
      <AuthActions
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        isValid={isValid}
        onSubmit={onLogin}
        onSubmitWithGoogle={onLoginWithGoogle}
        submitLabel="Sign in"
        googleLabel="Sign in with Google"
        isWithBorder={false}
        isWithPadding={false}
        className="w-full justify-center items-center"
        signupButtonClassName="w-48"
        googleButtonClassName="w-48"
      />
      <LoginAdditionalContent hideSignupLink={hideSignupLink} />
    </>
  );
}

export default LoginForm;
